<template>
  <div class="q-pa-lg">
    <div class="row justify-between items-start">
      <h1>Версии <span class="data-rows-number">{{ versionsTotal }}</span></h1>
      <q-btn @click="createVersion()" color="primary" class="q-mt-sm">Новая версия</q-btn>
    </div>
    <versions-list ref="versionsList"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import VersionsList from '@/VersionsList';
  import api from 'mixins/api';
  import {
    QBtn
  } from 'quasar';

  export default {
    name: 'VersionsView',
    components: {
      QBtn,
      VersionsList
    },
    mixins: [
      api
    ],
    data () {
      return {
        newUser: false
      };
    },
    computed: mapGetters({
      versionsTotal: 'versionsList/total'
    }),
    methods: {
      createVersion () {
        this.$q.dialog({
          title: 'Новая версия',
          color: 'primary',
          ok: true,
          cancel: true,
          prompt: {
            model: '',
            type: 'text'
          }
        }).then(data => {
          this.loading = true;
          this.api.post(`app-backend`, {
            'name': data
          }).then(() => {
            this.$refs.versionsList.updateVersions();
          }).catch(error => {
            this.loading = false;
          });
        });
      },
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/VersionsView.vue